/* global $ */
/* global google */
import Cookies from 'js-cookie';

function initGoogleAuth(clientId, element, loginSuccessApiUrl, extraDataCb, errorCb) {
  const script = document.createElement('script');
  script.src = 'https://accounts.google.com/gsi/client';
  script.setAttribute('defer', '');
  script.setAttribute('async', '');
  document.body.appendChild(script);
  script.onload = () => {
    const client = google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: 'https://www.googleapis.com/auth/userinfo.email ' + 'https://www.googleapis.com/auth/userinfo.profile',
      callback: (tokenResponse) => {
        const data = { token: tokenResponse.access_token, sso_provider: 'google' };

        if (extraDataCb) {
          Object.assign(data, extraDataCb());
        }

        $.post({
          url: loginSuccessApiUrl,
          headers: { 'X-CSRFToken': Cookies.get('csrftoken') },
          data,
          success: (response) => {
            if (response.redirect_to) {
              window.location.href = response.redirect_to;
            }
          },
          crossDomain: false
        }).fail((response) => {
          if (errorCb) {
            errorCb(response);
          }
        });
      }
    });

    element.addEventListener('click', () => {
      client.requestAccessToken();
    });
  };
}

export { initGoogleAuth };
